<template>
  <text-area-input-modal
    ref="input"
    @selectedElement="propagateChange"
    :title="title"
    :student="studentName"
    :byDefault="state"
    :edit="edit"
  />
</template>
<script>
import TextAreaInputModal from '@/components/diaryElements/TextAreaInputModal.vue'

export default {
  components: { TextAreaInputModal },
  props: {
    title: {
      type: String,
      default: () => 'Postre'
    },
    studentName: {
      type: String,
      default: () => 'Todos'
    },
    student: {
      type: Object,
      default: () => ({ name: '' })
    },
    byDefault: {
      type: String,
      default: () => ''
    },
    edit: {
      type: Boolean,
      default: () => false
    }
  },
  created: function () {
    this.state = !this.byDefault ? this.byDefault : ''
    if (this.student && this.student.dessert) this.state = this.student.dessert
  },
  data: () => ({
    enabled: false,
    state: ''
  }),
  methods: {
    setValue: function (value) {
      this.state = value
      this.$refs.input.setValue(value)
    },
    setEnable: function (value) {
      this.enabled = value
      this.$refs.input.setEnable(value)
    },
    propagateChange: function ({ item }) {
      this.state = item
      this.$emit('updatedElement', { dessert: this.state })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menuElements/Desserts.vue